// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var DOM$SmartcutsMacros = require("../../../DOM.bs.js");
var DOM__Node$SmartcutsMacros = require("../../../DOM__Node.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../../bs-utils/src/DeccoUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../../DOM__HtmlElement.bs.js");
var DOM__Event__ForSerialization$SmartcutsMacros = require("../../../DOM__Event__ForSerialization.bs.js");
var Virtualized__ContentEditable$SmartcutsMacros = require("../../../Virtualized__ContentEditable.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");
var ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros = require("./ContentScript__StateMachine__RecordingMode__Shared.bs.js");

var disconnect_encode = DeccoUtils$SmartcutsMacros.unitToUnit_encode;

var disconnect_decode = DeccoUtils$SmartcutsMacros.unitToUnit_decode;

function listener_encode(encoder_domMutationRecord, v) {
  if (v.TAG === /* DocumentBodyMutationObserverListener */0) {
    return [
            "DocumentBodyMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
          ];
  } else {
    return [
            "ContentEditableMutationObserverListener",
            Decco.arrayToJson(encoder_domMutationRecord, v._0)
          ];
  }
}

function listener_decode(decoder_domMutationRecord, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentEditableMutationObserverListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentEditableMutationObserverListener */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DocumentBodyMutationObserverListener" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.arrayFromJson(decoder_domMutationRecord, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DocumentBodyMutationObserverListener */0,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    if (v === /* Init */0) {
      return ["Init"];
    } else {
      return ["NotEditing"];
    }
  }
  switch (v.TAG | 0) {
    case /* WaitMutationObserverAttachTo */0 :
        return [
                "WaitMutationObserverAttachTo",
                Curry._1(encoder_domHtmlElement, v._0)
              ];
    case /* EditingContentEditable */1 :
        return [
                "EditingContentEditable",
                Virtualized__ContentEditable$SmartcutsMacros.Generic.t_encode(encoder_domHtmlElement, encoder_domNode, v._0),
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._1)
              ];
    case /* Exiting */2 :
        return [
                "Exiting",
                exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* Exited */3 :
        return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                      }), v._0)
              ];
    
  }
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  switch (v.TAG | 0) {
    case /* Dispatch */0 :
        return [
                "Dispatch",
                event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* SetupMutationObserver */1 :
        return [
                "SetupMutationObserver",
                Curry._1(encoder_domHtmlElement, v._0)
              ];
    case /* TearDownMutationObserver */2 :
        return [
                "TearDownMutationObserver",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
              ];
    
  }
}

function event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  if (typeof v === "number") {
    if (v === /* Initialize */0) {
      return ["Initialize"];
    } else {
      return ["MutationObserved"];
    }
  }
  switch (v.TAG | 0) {
    case /* SharedEvent */0 :
        return [
                "SharedEvent",
                ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_encode(encoder_domHtmlElement, encoder_domEvent, v._0)
              ];
    case /* BasicEventWhileContentEditing */1 :
        return [
                "BasicEventWhileContentEditing",
                ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
              ];
    case /* FocusOnContentEditable */2 :
        return [
                "FocusOnContentEditable",
                Curry._1(encoder_domNode, v._0)
              ];
    case /* MutationObserverAttachedTo */3 :
        return [
                "MutationObserverAttachedTo",
                Curry._1(encoder_domHtmlElement, v._0),
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._1)
              ];
    case /* Fail */4 :
        return [
                "Fail",
                failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    case /* Exit */5 :
        return [
                "Exit",
                exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v._0)
              ];
    
  }
}

function exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

function event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventWhileContentEditing" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventWhileContentEditing */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */5,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */4,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "FocusOnContentEditable" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FocusOnContentEditable */2,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Initialize */0
                  };
          }
      case "MutationObserved" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MutationObserved */1
                  };
          }
      case "MutationObserverAttachedTo" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* MutationObserverAttachedTo */3,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$4 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "SharedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = ContentScript__StateMachine__RecordingMode__Shared$SmartcutsMacros.event_decode(decoder_domHtmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SharedEvent */0,
                      _0: v0$4._0
                    }
                  };
          }
          var e$6 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), otherFailureReason_encode, v);
}

function failure_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), otherFailureReason_encode, v);
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "EditingContentEditable" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Virtualized__ContentEditable$SmartcutsMacros.Generic.t_decode(decoder_domHtmlElement, decoder_domNode, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* EditingContentEditable */1,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Exited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                  return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exited */3,
                      _0: v0._0
                    }
                  };
          }
          var e$2 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Exiting" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exiting */2,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Init" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* Init */0
                  };
          }
      case "NotEditing" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NotEditing */1
                  };
          }
      case "WaitMutationObserverAttachTo" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WaitMutationObserverAttachTo */0,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "SetupMutationObserver" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_domHtmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SetupMutationObserver */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "TearDownMutationObserver" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TearDownMutationObserver */2,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function failure_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), otherFailureReason_decode, v);
}

function exiting_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Js_dict.fromArray([[
                "allExitReasons",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
                      }), v.allExitReasons)
              ]]);
}

function exiting_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
          return exitReason_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict._0, "allExitReasons"), null));
  if (allExitReasons.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              allExitReasons: allExitReasons._0
            }
          };
  }
  var e = allExitReasons._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".allExitReasons" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function errorContext_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_domHtmlElement, encoder_domNode, encoder_domMutationRecord, encoder_domEvent, param);
              }), (function (param) {
                return listener_encode(encoder_domMutationRecord, param);
              }), v);
}

function errorContext_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_domHtmlElement, decoder_domNode, decoder_domMutationRecord, decoder_domEvent, param);
              }), (function (param) {
                return listener_decode(decoder_domMutationRecord, param);
              }), v);
}

var Generic = {
  disconnect_encode: disconnect_encode,
  disconnect_decode: disconnect_decode,
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  state_encode: state_encode,
  state_decode: state_decode,
  exiting_encode: exiting_encode,
  exiting_decode: exiting_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode
};

var Regular = {};

function listener_encode$1(v) {
  return listener_encode(DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, v);
}

function listener_decode$1(v) {
  return listener_decode(DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, v);
}

function state_encode$1(v) {
  return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function state_decode$1(v) {
  return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function event_encode$1(v) {
  return event_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function event_decode$1(v) {
  return event_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function sideEffect_encode$1(v) {
  return sideEffect_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function sideEffect_decode$1(v) {
  return sideEffect_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function failure_encode$1(v) {
  return failure_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function failure_decode$1(v) {
  return failure_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function errorContext_encode$1(v) {
  return errorContext_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function errorContext_decode$1(v) {
  return errorContext_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

function exitReason_encode$1(v) {
  return exitReason_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Node$SmartcutsMacros.ForSerialization.t__encode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function exitReason_decode$1(v) {
  return exitReason_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Node$SmartcutsMacros.ForSerialization.t__decode, DOM$SmartcutsMacros.$$MutationRecord.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

var ForSerialization = {
  listener_encode: listener_encode$1,
  listener_decode: listener_decode$1,
  state_encode: state_encode$1,
  state_decode: state_decode$1,
  event_encode: event_encode$1,
  event_decode: event_decode$1,
  sideEffect_encode: sideEffect_encode$1,
  sideEffect_decode: sideEffect_decode$1,
  failure_encode: failure_encode$1,
  failure_decode: failure_decode$1,
  errorContext_encode: errorContext_encode$1,
  errorContext_decode: errorContext_decode$1,
  exitReason_encode: exitReason_encode$1,
  exitReason_decode: exitReason_decode$1
};

exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* DOM-SmartcutsMacros Not a pure module */
